"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMuiTextField = getMuiTextField;
function getMuiTextField(palette) {
  return {
    defaultProps: {
      InputLabelProps: {
        shrink: true
      },
      // @ts-ignore missing in defaultProps type
      'data-testid': 'required'
    },
    styleOverrides: {
      root: {
        '& fieldset': {
          '& legend': {
            fontSize: '14px',
            fontWeight: 400,
            lineHeight: '22px',
            marginLeft: '-9px',
            position: 'absolute'
          },
          borderColor: palette.grey[600],
          minHeight: '32px',
          top: '1px'
        },
        '&:focus': {
          '& fieldset': {
            borderColor: palette.primary.main,
            boxShadow: "0px 0px 0px 4px ".concat(palette.primary.light)
          },
          '.MuiInputLabel-root': {
            color: palette.primary.main
          }
        },
        '&:has(.MuiOutlinedInput-root.Mui-disabled)': {
          '.MuiInputLabel-root': {
            color: palette.grey[300]
          }
        },
        '&:has(.MuiOutlinedInput-root.Mui-error)': {
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: palette.error[700]
          },
          '.MuiInputLabel-root': {
            color: palette.error[700]
          }
        },
        '&:has(.MuiOutlinedInput-root.Mui-error.Mui-focused)': {
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: palette.error[700]
          },
          '.MuiInputLabel-root': {
            color: palette.error[700]
          }
        },
        '&:has(.MuiOutlinedInput-root.Mui-focused)': {
          '.MuiInputLabel-root': {
            color: palette.primary.main
          }
        },
        '&:hover': {
          '&:has(.MuiOutlinedInput-root.Mui-disabled)': {
            '.MuiInputLabel-root': {
              color: palette.grey[300]
            }
          },
          '.MuiInputLabel-root': {
            color: palette.grey[800]
          },
          '.MuiOutlinedInput-root': {
            '& .MuiInputAdornment-root': {
              color: palette.grey[600]
            },
            '& .MuiOutlinedInput-input': {
              color: palette.common.black
            },
            '&.Mui-disabled': {
              '& .MuiInputAdornment-root': {
                color: palette.grey[300]
              },
              '& .MuiOutlinedInput-input': {
                color: palette.grey[600]
              }
            },
            borderColor: palette.grey[800]
          }
        },
        '.MuiFormHelperText-root': {
          '&.Mui-disabled': {
            color: palette.grey[300]
          },
          '&.Mui-error': {
            color: palette.error[700],
            fontSize: '12px',
            fontWeight: 400,
            lineHeight: '16px',
            marginTop: '4px'
          },
          color: palette.grey[500],
          fontSize: '12px',
          fontWeight: 400,
          lineHeight: '16px',
          margin: '4px 0 0'
        },
        '.MuiInputAdornment-root': {
          '.MuiSvgIcon-root': {
            height: 20,
            width: 22
          }
        },
        '.MuiInputLabel-asterisk': {
          color: palette.error.main
        },
        '.MuiInputLabel-root': {
          color: palette.grey[800],
          fontSize: '14px',
          fontWeight: 400,
          lineHeight: '22px',
          margin: '0 0 6px -13px'
        },
        '.MuiOutlinedInput-root': {
          '& .MuiInputAdornment-root': {
            '& svg': {
              height: '20px',
              width: '20px'
            },
            color: palette.grey[500]
          },
          '& .MuiOutlinedInput-input': {
            color: palette.grey[800],
            fontSize: '14px',
            fontWeight: 400,
            height: 'auto',
            lineHeight: '22px',
            padding: '6px 8px'
          },
          '&.Mui-disabled': {
            '& .MuiInputAdornment-root': {
              color: palette.grey[300]
            },
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: "".concat(palette.grey[300], " !important")
            },
            backgroundColor: palette.grey[50],
            borderColor: palette.grey[300]
          },
          '&.Mui-focused': {
            '& .MuiOutlinedInput-input': {
              color: palette.common.black
            },
            '& fieldset': {
              borderWidth: '1px'
            },
            borderColor: palette.primary.main,
            boxShadow: "0px 0px 0px 4px ".concat(palette.primary.light)
          },
          '&:has(.MuiInputAdornment-positionStart)': {
            '& .MuiOutlinedInput-input': {
              padding: '5px 0'
            },
            padding: '1px 8px'
          },
          '&:has(.MuiInputBase-inputMultiline)': {
            '& .MuiOutlinedInput-input': {
              padding: 0
            },
            padding: '4px 8px'
          },
          '&:hover': {
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: palette.grey[600]
            },
            '&.Mui-disabled': {
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: "".concat(palette.grey[300], " !important")
              }
            },
            '&.Mui-error': {
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: palette.error[700]
              }
            }
          },
          marginTop: '10px'
        }
      }
    }
  };
}